import React from 'react';
import { Box, Drawer, SwipeableDrawer, IconButton, useMediaQuery, useTheme } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { feedbackActions } from 'features/feedback/store/feedback.slice';
import TypePicker from 'features/feedback/components/TypePicker';
import BugForm from 'features/feedback/components/BugForm';
import ReviewForm from 'features/feedback/components/ReviewForm';
import IdeaForm from 'features/feedback/components/IdeaForm';
import SubmitSuccess from 'features/feedback/components/SubmitStates';

const TITLES: Record<string, string> = {
  type: 'Залишити відгук',
  bug: 'Повідомити про баг',
  review: 'Ваш відгук',
  idea: 'Запропонувати ідею',
  success: '',
};

const FeedbackDrawer: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { drawerOpen, step, formState } = useAppSelector((s) => s.feedback);

  const close = () => { if (formState !== 'submitting') dispatch(feedbackActions.closeDrawer()); };
  const back = () => dispatch(feedbackActions.back());

  const body = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          height: 56, flex: '0 0 auto', px: 1.5, display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', borderBottom: '1px solid #eee',
        }}
      >
        <Box sx={{ width: 36 }}>
          {step !== 'type' && step !== 'success' && (
            <IconButton size="small" onClick={back} aria-label="Назад">
              <ChevronLeftIcon />
            </IconButton>
          )}
        </Box>
        <Box sx={{ fontSize: 18, fontWeight: 700 }}>{TITLES[step]}</Box>
        <IconButton size="small" onClick={close} aria-label="Закрити" disabled={formState === 'submitting'}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
        {step === 'type' && <TypePicker />}
        {step === 'bug' && <BugForm />}
        {step === 'review' && <ReviewForm />}
        {step === 'idea' && <IdeaForm />}
        {step === 'success' && <SubmitSuccess />}
      </Box>
    </Box>
  );

  if (isMobile) {
    return (
      <SwipeableDrawer
        anchor="bottom"
        open={drawerOpen}
        onOpen={() => {}}
        onClose={close}
        disableSwipeToOpen
        PaperProps={{ sx: { height: '85vh', borderRadius: '22px 22px 0 0' } }}
      >
        {body}
      </SwipeableDrawer>
    );
  }

  return (
    <Drawer anchor="right" disableScrollLock open={drawerOpen} onClose={close} PaperProps={{ sx: { width: 440 } }}>
      {body}
    </Drawer>
  );
};

export default FeedbackDrawer;
